export default function Packages() {
  return (
    <section className="section-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center mb-16">
          <h1 className="section-title">Packages</h1>
          <div className="gradient-line mx-auto"></div>
          <p className="text-lg text-gray-700 mt-6">
            A clear path from clarity to growth
          </p>
        </div>

        <div className="space-y-20">
          {/* Wise Check */}
          <div>
            <h2 className="text-3xl font-bold text-navy mb-4">Wise Check</h2>
            <p className="italic text-gray-600 mb-6">Clarity before action</p>

            <p className="text-gray-700 mb-6">
              Wise Check is a structured diagnostic that identifies what’s really holding your business back and where the biggest opportunities exist.
            </p>

            <h3 className="font-semibold text-navy mb-2">What’s included</h3>
            <ul className="list-disc list-inside text-gray-700 mb-6 space-y-1">
              <li>Business, marketing, sales, and systems assessment</li>
              <li>Review of current tools, workflows, and activity</li>
              <li>Identification of inefficiencies and gaps</li>
              <li>Wise Check Scorecard</li>
              <li>Prioritised 90-day action plan</li>
            </ul>

            <p className="font-semibold text-navy">Outcome</p>
            <p className="text-gray-700 mb-4">
              Clear direction, confidence, and a practical roadmap for what to fix first.
            </p>

            <p className="text-gray-700">
              <strong>Investment guide:</strong> $1,500 – $3,500
            </p>
          </div>

          {/* Wise Workshop */}
          <div>
            <h2 className="text-3xl font-bold text-navy mb-4">Wise Workshop</h2>
            <p className="italic text-gray-600 mb-6">Design the right way forward</p>

            <p className="text-gray-700 mb-6">
              A collaborative process aligning brand, marketing, sales, and systems into a clear operating model.
            </p>

            <h3 className="font-semibold text-navy mb-2">What’s included</h3>
            <ul className="list-disc list-inside text-gray-700 mb-6 space-y-1">
              <li>Strategy and planning workshop</li>
              <li>Brand positioning and messaging refinement</li>
              <li>Marketing and lead-generation strategy</li>
              <li>Workflow and system design</li>
              <li>Documented execution roadmap</li>
            </ul>

            <p className="font-semibold text-navy">Outcome</p>
            <p className="text-gray-700 mb-4">
              Alignment, structure, and a strategy your team can execute.
            </p>

            <p className="text-gray-700">
              <strong>Investment guide:</strong> $4,000 – $8,000
            </p>
          </div>

          {/* Grow Wise */}
          <div>
            <h2 className="text-3xl font-bold text-navy mb-4">Grow Wise</h2>
            <p className="italic text-gray-600 mb-6">Implementation, partnership, and scale</p>

            <p className="text-gray-700 mb-6">
              Ongoing consulting and execution support to embed strategy and drive performance.
            </p>

            <h3 className="font-semibold text-navy mb-2">What’s included</h3>
            <ul className="list-disc list-inside text-gray-700 mb-6 space-y-1">
              <li>Hands-on marketing execution</li>
              <li>CRM, automation, and reporting setup</li>
              <li>Workflow implementation and refinement</li>
              <li>Performance tracking and insights</li>
              <li>Ongoing strategic support</li>
            </ul>

            <p className="font-semibold text-navy">Outcome</p>
            <p className="text-gray-700 mb-4">
              Sustainable growth and a business that runs with clarity and control.
            </p>

            <p className="text-gray-700">
              <strong>Investment guide:</strong> $2,000 – $7,500+ per month
            </p>
          </div>

          {/* CTA */}
          <div className="gradient-card text-center">
            <h2 className="text-2xl font-bold text-navy mb-4">
              Not sure where to start?
            </h2>
            <p className="text-gray-700 mb-6">
              Most clients begin with Wise Check to gain clarity before building or scaling.
            </p>
            <a href="/wise-check" className="cta-button-large inline-block">
              Start with Wise Check
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}